import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingStepService } from '../services/booking-step.service';
import { BookingStepEnum } from '../models/booking-step.enum';
import { map } from 'rxjs/operators';
import { OrderStateService } from '../../order/services/order-state.service';
import { BookingProductStepService } from '../services/booking-product-step.service';

@Injectable({
  providedIn: 'root'
})
export class BookingSingleProductConfigurationGuard implements CanActivate {

  constructor(
    private bookingStepService: BookingStepService,
    private router: Router,
    private orderStateService: OrderStateService,
    private bookingProductStepService: BookingProductStepService,
  ) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.bookingStepService.isBookingSingleProductConfigurationAvailable || this.bookingProductStepService.isBookingProductConfigurationAvailable) {
      return true;
    }

    if (this.orderStateService.isNeedReloadOrder) {
      return this.bookingStepService.initFromLoadOrder(BookingStepEnum.ShowProductConfigurationPage).pipe(map(_ => true));
    }

    this.router.navigate(['/booking']);
    return false;
  }
}
